// Office "My account" page. The one personal settings page in the office shell: where you are signed in and "Sign
// out everywhere" (Session ASB Item 3, SignInSessionsCard). Everything here is about the signed-in person only;
// managing OTHER people's accounts stays on the Office users and Engineers pages.
//
// The authenticator app / step-up card (Session ASB Item 4) was removed here by Director decision (Session ASJ,
// reversing D-SEC-2); Session ASL deleted the card, its routes and the columns behind it.
import { PageHeader } from "../../components/PageHeader";
import { SignInSessionsCard } from "./SignInSessionsCard";

export function MyAccountPage() {
  return (
    <div>
      <PageHeader className="mb-4" title="My account" subtitle="Where you are signed in." />
      <div className="space-y-4">
        <SignInSessionsCard />
      </div>
    </div>
  );
}
